import { IonButton, IonCol, IonGrid, IonRow } from '@ionic/react';

import styles from '@components/fieldsNative/ButtonThatLooksLikeASelect.module.css';
import Icon from '@components/text/Icon';
import BodyCopy from '@components/typography/BodyCopy';

type Props = React.ComponentProps<typeof IonButton>;

const ButtonThatLooksLikeASelect = ({ children, className, ...ionButtonProps }: Props) => (
  <IonButton className={`${className} ${styles.fakeSelect}`} {...ionButtonProps}>
    <IonGrid>
      <IonRow>
        <IonCol>
          <div className={`ion-text-start ${styles.fakeSelectText}`}>
            <BodyCopy color="neutral500">{children}</BodyCopy>
          </div>
        </IonCol>
        <IonCol size="auto">
          <Icon color="gray" icon="chevronDown" />
        </IonCol>
      </IonRow>
    </IonGrid>
  </IonButton>
);

export default ButtonThatLooksLikeASelect;
